/*! StrategyTypes.js */

/**
 * @enum {string}
 * @type {{EMBED: string, SCRIPT: string}}
 */
const StrategyTypes = {
    EMBED: "embed",
    SCRIPT: "script"
};

export default StrategyTypes;
